import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { RequestQuoteComponent } from "../shared/request-quote/request-quote.component";
import { TrackingService } from  '../../service/tracking.service';
import {DialogState, ScrollBarData} from "../shared/scroll-bar-data";


@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  constructor(private dialog: MatDialog, private trackingService: TrackingService) { }

  ngOnInit() {
  }

  opendialog() {
    const hasScrollbar = window.innerWidth > document.documentElement.clientWidth;
    const matDialogRef = this.dialog.open(RequestQuoteComponent);
    ScrollBarData.updateBodyWidth(DialogState.OPEN, hasScrollbar);
    matDialogRef.afterClosed().subscribe(() => ScrollBarData.updateBodyWidth(DialogState.CLOSE));
  }

  sendEmail() {
    this.trackingService.emailOpened();
  }

  makeaCall() {
    this.trackingService.phoneClicked();
  }
}



// WEBPACK FOOTER //
// /var/www/apps/asna/front-end/public_html/src/app/components/footer/footer.component.ts